import { t } from 'i18next';
import React, { ChangeEvent } from 'react';
import { useRecoilState } from 'recoil';
import { tutorStateAtom } from 'src/app/state/atoms';
import { ReactComponent as SendSvg } from 'src/assets/images/send.svg';

type SendButtonPropTypes = {
  className?: string;
  isDisabled?: boolean;
  onClickHandler?: (event: React.FormEvent<HTMLFormElement> | ChangeEvent<EventTarget>) => void;
};

/**
 * Presentational common Button component
 */
function SendButton(props: SendButtonPropTypes) {
  const { onClickHandler, isDisabled, className } = props;
  const [tutorState] = useRecoilState(tutorStateAtom);

  const { isSMEMode } = tutorState;

  return (
    <button
      type='submit'
      className={`mx-space-2 flex-none inline-flex items-center justify-center w-10 h-10 rounded-full
      transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2
      focus-visible:outline-offset-2 focus-visible:outline-accent-blue ${
        isDisabled
          ? `${
              isSMEMode ? 'bg-[var(--surface-dim)] ' : ''
            }text-[var(--accent-muted)] cursor-not-allowed`
          : 'bg-accent-blue text-white hover:bg-accent-button-hover active:bg-accent-dark-blue'
      } ${className}`}
      onClick={onClickHandler}
      disabled={Boolean(isDisabled)}
      aria-label={t('SEND')}
      aria-disabled={Boolean(isDisabled)}
    >
      {/* Optical nudge: the arrow art sits left-of-centre in its own viewBox,
          so shift it slightly right to visually centre it in the circle. */}
      {<SendSvg className='translate-x-[2px]' height={26} width={26} aria-hidden={true} />}
    </button>
  );
}

export default SendButton;
